import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';

export type FieldType = 'customField' | 'costCenter' | 'expenseCategory';
export type ExportLevel = 'header' | 'headerLine';

export type FieldContext = {
  fieldName: string;
  fieldNamePlural: string;
  line1: string;
  line2: string;
};

export const getFieldContext = (
  fieldType: FieldType,
  exportLevel: ExportLevel,
  t: TGlobalFunctionTyped,
): FieldContext => {
  let fieldName: string;
  let fieldNamePlural: string;
  let line1: string;
  let line2: string;

  switch (fieldType) {
    case 'customField':
      fieldName = t(
        'accounting-integration.exportSettingsOnboardingGuide.fieldNames.customField.fieldName',
      );
      fieldNamePlural = t(
        'accounting-integration.exportSettingsOnboardingGuide.fieldNames.customField.fieldNamePlural',
      );
      [line1, line2] =
        exportLevel === 'header'
          ? ['Hardware', 'Furniture']
          : ['Internal: Manufacturing', 'Internal: R&D'];
      break;
    case 'costCenter':
      fieldName = t(
        'accounting-integration.exportSettingsOnboardingGuide.fieldNames.costCenter.fieldName',
      );
      fieldNamePlural = t(
        'accounting-integration.exportSettingsOnboardingGuide.fieldNames.costCenter.fieldNamePlural',
      );
      [line1, line2] =
        exportLevel === 'header'
          ? ['Marketing', 'Sales']
          : ['Production : Assembly', 'Production : Inspection'];
      break;
    case 'expenseCategory':
      fieldName = t(
        'accounting-integration.exportSettingsOnboardingGuide.fieldNames.expenseCategory.fieldName',
      );
      fieldNamePlural = t(
        'accounting-integration.exportSettingsOnboardingGuide.fieldNames.expenseCategory.fieldNamePlural',
      );
      [line1, line2] =
        exportLevel === 'header'
          ? ['Hardware', 'Furniture']
          : ['Internal: Manufacturing', 'Internal: R&D'];
      break;
    default:
      throw new Error(`Unsupported field type: ${fieldType}`);
  }

  return { fieldName, fieldNamePlural, line1, line2 };
};
